module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-espace-manager h-100 noselect",
    attrs: {
      "data-testid": "manager-requestsList"
    }
  }, [_c('div', {
    staticClass: "row area"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1 d-flex"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "data-testid": "manager-requestsList-title"
    }
  }, [_vm._v("DEMANDES\n                            "), (!_vm.switchType) ? _c('span', [_vm._v("DE VALIDATION")]) : _c('span', [_vm._v("D'ANNULATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "right ml-auto"
  }, [_c('div', {
    staticClass: "custom-btn-group",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_c('button', {
    staticClass: "custom-btn custom-btn-left custom-btn-blue d-flex align-items-center",
    staticStyle: {
      "line-height": "20px"
    },
    attrs: {
      "type": "button",
      "data-testid": "manager-requestsList-validation-button",
      "disabled": !_vm.switchType
    },
    on: {
      "click": function($event) {
        _vm.switchOngletType()
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Validation")]), _vm._v(" "), (_vm.compteurAbsenceEnAttente > 0) ? _c('span', {
    staticClass: "badge badge-pill ml-2"
  }, [_vm._v("\n                                    " + _vm._s(_vm.compteurAbsenceEnAttente) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "custom-btn custom-btn-right custom-btn-blue d-flex align-items-center",
    staticStyle: {
      "line-height": "20px"
    },
    attrs: {
      "type": "button",
      "data-testid": "manager-requestsList-annulation-button",
      "disabled": _vm.switchType
    },
    on: {
      "click": function($event) {
        _vm.switchOngletType()
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Annulation")]), _vm._v(" "), (_vm.compteurAbsenceAnnulation > 0) ? _c('span', {
    staticClass: "badge badge-pill ml-2"
  }, [_vm._v("\n                                    " + _vm._s(_vm.compteurAbsenceAnnulation) + "\n                                ")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-wrap",
    staticStyle: {
      "height": "calc(100% - 33px)"
    }
  }, [_c('div', {
    staticClass: "h-100",
    class: _vm.dataReady ? 'd-block' : 'd-none'
  }, [_c('demande-en-attente-component', {
    class: !_vm.switchType ? '' : 'd-none',
    attrs: {
      "demandeEnAttente": _vm.demandeEnAttente
    },
    on: {
      "afficherModalChangerEtatAbsence": _vm.afficherModalChangerEtatAbsence,
      "afficherModalValiderAbsence": _vm.afficherModalValiderAbsence
    }
  }), _vm._v(" "), _c('annulation-en-attente-component', {
    class: _vm.switchType ? '' : 'd-none',
    attrs: {
      "annulationEnAttente": _vm.annulationEnAttente
    },
    on: {
      "afficherModalChangerEtatAbsence": _vm.afficherModalChangerEtatAbsence
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-100",
    class: !_vm.dataReady ? 'd-block' : 'd-none'
  }, [_c('div', {
    staticClass: "card-salarie-content p-0 m-0 h-all"
  }, [_c('loader')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb5a659"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/listeDesDemandes/espaceManager/espaceManager.vue.html
// module id = URxE
// module chunks = 2